module.exports = __webpack_public_path__ + "static/media/Building.479f03a3.svg";